import React from 'react';
import { ArrowLeft, Mic, Calendar, MapPin } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import WhatsAppButton from '../../components/WhatsAppButton';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../i18n/pageTranslations';

const Ponencias = () => {
  const navigate = useNavigate();
  const lang = useLanguage();

  const texts = {
    es: {
      backTo: 'Volver a Dr. Norro',
      title: 'Ponencias y Congresos',
      subtitle: 'Participación del Dr. Norro en eventos científicos',
      ponencias: [
        {
          titulo: 'Técnicas básicas y avanzadas de Rinomodelación',
          evento: 'Congreso Sociedad Española de Medicina Estética (SEME)',
          fecha: '2015',
          lugar: 'Madrid',
          descripcion: 'Presentación de las técnicas desarrolladas por el Dr. Norro para la rinomodelación permanente y temporal.'
        },
        {
          titulo: 'Anatomía Estética de la Nariz',
          evento: 'Congreso Sociedad Española de Medicina Estética (SEME)',
          fecha: '2015',
          lugar: 'Madrid',
          descripcion: 'Análisis detallado de la anatomía nasal aplicada a procedimientos estéticos no quirúrgicos.'
        },
        {
          titulo: 'Bioplastia nasal: 10 años de experiencia',
          evento: 'Jornadas de Medicina Estética',
          fecha: '2017',
          lugar: 'Barcelona',
          descripcion: 'Revisión de una década de experiencia en rinomodelación con resultados y casos clínicos.'
        },
        {
          titulo: 'Materiales de relleno en rinomodelación',
          evento: 'Congreso Internacional de Medicina Estética',
          fecha: '2019',
          lugar: 'Lisboa',
          descripcion: 'Comparativa de materiales y técnicas para rinomodelación temporal y permanente.'
        }
      ],
      trainingTitle: 'Formación para profesionales',
      trainingDesc: 'El Dr. Norro imparte formación en técnicas de rinomodelación a otros médicos.',
      requestInfo: 'Solicitar información',
    },
    en: {
      backTo: 'Back to Dr. Norro',
      title: 'Lectures and Conferences',
      subtitle: 'Dr. Norro\'s participation in scientific events',
      ponencias: [
        {
          titulo: 'Basic and Advanced Rhinomodeling Techniques',
          evento: 'Spanish Society of Aesthetic Medicine Congress (SEME)',
          fecha: '2015',
          lugar: 'Madrid',
          descripcion: 'Presentation of techniques developed by Dr. Norro for permanent and temporary rhinomodeling.'
        },
        {
          titulo: 'Aesthetic Anatomy of the Nose',
          evento: 'Spanish Society of Aesthetic Medicine Congress (SEME)',
          fecha: '2015',
          lugar: 'Madrid',
          descripcion: 'Detailed analysis of nasal anatomy applied to non-surgical aesthetic procedures.'
        },
        {
          titulo: 'Nasal Bioplasty: 10 Years of Experience',
          evento: 'Aesthetic Medicine Conference',
          fecha: '2017',
          lugar: 'Barcelona',
          descripcion: 'Review of a decade of experience in rhinomodeling with results and clinical cases.'
        },
        {
          titulo: 'Filler Materials in Rhinomodeling',
          evento: 'International Congress of Aesthetic Medicine',
          fecha: '2019',
          lugar: 'Lisbon',
          descripcion: 'Comparison of materials and techniques for temporary and permanent rhinomodeling.'
        }
      ],
      trainingTitle: 'Training for professionals',
      trainingDesc: 'Dr. Norro provides training in rhinomodeling techniques to other doctors.',
      requestInfo: 'Request information',
    },
    fr: {
      backTo: 'Retour à Dr. Norro',
      title: 'Conférences et Congrès',
      subtitle: 'Participation du Dr. Norro aux événements scientifiques',
      ponencias: [
        {
          titulo: 'Techniques de base et avancées de Rhinomodelage',
          evento: 'Congrès de la Société Espagnole de Médecine Esthétique (SEME)',
          fecha: '2015',
          lugar: 'Madrid',
          descripcion: 'Présentation des techniques développées par le Dr. Norro pour le rhinomodelage permanent et temporaire.'
        },
        {
          titulo: 'Anatomie Esthétique du Nez',
          evento: 'Congrès de la Société Espagnole de Médecine Esthétique (SEME)',
          fecha: '2015',
          lugar: 'Madrid',
          descripcion: 'Analyse détaillée de l\'anatomie nasale appliquée aux procédures esthétiques non chirurgicales.'
        },
        {
          titulo: 'Bioplastie nasale: 10 ans d\'expérience',
          evento: 'Journées de Médecine Esthétique',
          fecha: '2017',
          lugar: 'Barcelone',
          descripcion: 'Révision d\'une décennie d\'expérience en rhinomodelage avec résultats et cas cliniques.'
        },
        {
          titulo: 'Matériaux de comblement en rhinomodelage',
          evento: 'Congrès International de Médecine Esthétique',
          fecha: '2019',
          lugar: 'Lisbonne',
          descripcion: 'Comparaison des matériaux et techniques pour le rhinomodelage temporaire et permanent.'
        }
      ],
      trainingTitle: 'Formation pour professionnels',
      trainingDesc: 'Le Dr. Norro dispense des formations en techniques de rhinomodelage à d\'autres médecins.',
      requestInfo: 'Demander des informations',
    },
    pt: {
      backTo: 'Voltar para Dr. Norro',
      title: 'Palestras e Congressos',
      subtitle: 'Participação do Dr. Norro em eventos científicos',
      ponencias: [
        {
          titulo: 'Técnicas básicas e avançadas de Rinomodelação',
          evento: 'Congresso da Sociedade Espanhola de Medicina Estética (SEME)',
          fecha: '2015',
          lugar: 'Madrid',
          descripcion: 'Apresentação das técnicas desenvolvidas pelo Dr. Norro para a rinomodelação permanente e temporária.'
        },
        {
          titulo: 'Anatomia Estética do Nariz',
          evento: 'Congresso da Sociedade Espanhola de Medicina Estética (SEME)',
          fecha: '2015',
          lugar: 'Madrid',
          descripcion: 'Análise detalhada da anatomia nasal aplicada a procedimentos estéticos não cirúrgicos.'
        },
        {
          titulo: 'Bioplastia nasal: 10 anos de experiência',
          evento: 'Jornadas de Medicina Estética',
          fecha: '2017',
          lugar: 'Barcelona',
          descripcion: 'Revisão de uma década de experiência em rinomodelação com resultados e casos clínicos.'
        },
        {
          titulo: 'Materiais de preenchimento em rinomodelação',
          evento: 'Congresso Internacional de Medicina Estética',
          fecha: '2019',
          lugar: 'Lisboa',
          descripcion: 'Comparação de materiais e técnicas para rinomodelação temporária e permanente.'
        }
      ],
      trainingTitle: 'Formação para profissionais',
      trainingDesc: 'O Dr. Norro ministra formação em técnicas de rinomodelação para outros médicos.',
      requestInfo: 'Solicitar informações',
    },
  };

  const t = texts[lang] || texts.es;

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Breadcrumb */}
      <div className="pt-24 pb-4 bg-cream">
        <div className="container mx-auto px-4">
          <button 
            onClick={() => navigate('/rinomodelacion/doctor')}
            className="flex items-center gap-2 text-gold hover:text-gold transition-colors"
          >
            <ArrowLeft size={20} />
            <span>{t.backTo}</span>
          </button>
        </div>
      </div>

      {/* Hero */}
      <section className="py-16 px-4 bg-gradient-to-b from-cream to-white">
        <div className="container mx-auto max-w-5xl text-center">
          <h1 className="text-4xl md:text-5xl font-light text-[#1C1C1A] mb-6">
            {t.title}
          </h1>
          <p className="text-xl text-text-secondary">
            {t.subtitle}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          
          <div className="space-y-6 mb-12">
            {t.ponencias.map((ponencia, index) => (
              <Card key={index} className="p-6 hover:shadow-lg transition-all border border-gray-100 rounded-none">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gold/10 rounded-none flex items-center justify-center flex-shrink-0">
                    <Mic className="text-gold" size={24} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-[#1C1C1A] mb-2">
                      {ponencia.titulo}
                    </h3>
                    <p className="text-gold font-medium mb-2">{ponencia.evento}</p>
                    <div className="flex items-center gap-4 text-sm text-text-muted mb-3">
                      <span className="flex items-center gap-1">
                        <Calendar size={14} />
                        {ponencia.fecha}
                      </span>
                      <span className="flex items-center gap-1">
                        <MapPin size={14} />
                        {ponencia.lugar}
                      </span>
                    </div>
                    <p className="text-text-secondary">
                      {ponencia.descripcion}
                    </p>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          <div className="bg-gradient-to-r from-[#1C1C1A] to-[#1C1C1A] p-8 rounded-none text-white text-center">
            <h3 className="text-2xl font-light mb-4">
              {t.trainingTitle}
            </h3>
            <p className="text-white/80 mb-6">
              {t.trainingDesc}
            </p>
            <Button 
              onClick={() => navigate('/rinomodelacion/contacto')}
              className="bg-gold hover:bg-gold text-white"
            >
              {t.requestInfo}
            </Button>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Ponencias;
